
import React from 'react';
import { useEffect } from 'react';

const Privacy = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="bg-gray-50 min-h-screen pt-24 md:pt-32 pb-16 md:pb-24">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 bg-white p-8 md:p-12 shadow-md rounded-2xl border border-gray-100">
                <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8">Politique de Confidentialité et Gestion des Données</h1>
                
                <div className="prose prose-blue max-w-none text-gray-600 space-y-6">
                    <p className="text-sm text-gray-500">Dernière mise à jour : Mars 2026</p>
                    
                    <p>La protection de vos données personnelles est une priorité. La présente politique de confidentialité a pour but de vous informer sur la manière dont nous collectons, utilisons et protégeons vos données lorsque vous naviguez sur notre site internet et utilisez nos services.</p>

                    <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">1. Données collectées et finalités</h2>
                    <p>Dans le cadre de votre visite et de vos interactions, nous sommes amenés à collecter les données suivantes :</p>
                    <ul className="list-disc pl-5 space-y-2">
                        <li><strong>Données d'identification</strong> : Nom, prénom, adresse, numéro de téléphone, adresse e-mail lors de l'utilisation de nos formulaires de contact.</li>
                        <li><strong>Données de recherche immobilière</strong> : Type de bien recherché, budget, localisation souhaitée.</li>
                        <li><strong>Données de navigation (Cookies)</strong> : Comportement de navigation, pages consultées.</li>
                    </ul>

                    <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">2. Pourquoi collectons-nous ces données ?</h2>
                    <ul className="list-disc pl-5 space-y-2">
                        <li><strong>La gestion de la relation client :</strong> Pour vous recontacter suite à une demande d'information sur un bien, ou pour une estimation immobilière.</li>
                        <li><strong>Le suivi de vos projets immobiliers :</strong> Pour vous proposer des biens correspondant à vos critères.</li>
                        <li><strong>L'amélioration de nos services :</strong> Les données de navigation nous aident à analyser l'audience de notre site internet.</li>
                    </ul>

                    <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">3. Les destinataires de vos données</h2>
                    <p>Les données collectées sont strictement destinées à une utilisation interne par notre agence et nos collaborateurs. Nous ne vendons, ni ne louons vos données personnelles à des prestataires de services tiers. Vos informations peuvent ponctuellement être partagées avec nos prestataires techniques (hébergement sécurisé) soumis à de strictes obligations de confidentialité.</p>

                    <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">4. Durée de conservation</h2>
                    <p>Nous conservons vos données pour la durée strictement nécessaire :</p>
                    <ul className="list-disc pl-5 space-y-2">
                        <li><strong>Les données liées aux demandes de contact</strong> sont conservées pendant <strong>3 ans</strong> à compter du dernier contact émanant de votre part.</li>
                        <li><strong>Les données liées aux cookies de navigation</strong> ont une durée de vie maximale de <strong>13 mois</strong>.</li>
                    </ul>

                    <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">5. Vos droits (Conformité RGPD)</h2>
                    <p>Conformément à la réglementation en vigueur, vous disposez des droits suivants sur vos données :</p>
                    <ul className="list-disc pl-5 space-y-2">
                        <li>Droit d'accès et de rectification de vos données.</li>
                        <li>Droit d'effacement (droit à l'oubli) et de limitation du traitement.</li>
                        <li>Droit d'opposition au traitement de vos données pour des motifs légitimes.</li>
                    </ul>
                    <p className="mt-4">Pour exercer ces droits, vous pouvez nous contacter à tout moment via le formulaire de contact du site. Nous nous engageons à vous répondre dans un délai maximum de 30 jours.</p>

                    <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">6. Gestion des Cookies</h2>
                    <p>Le site utilise des cookies essentiels pour garantir son fonctionnement. Avec votre consentement explicite, collecté à votre arrivée sur le site, nous pouvons également utiliser des cookies à des fins d'analyse statistique de notre fréquentation. Vous pouvez révoquer ces choix ou vider le cache de votre navigateur à tout instant.</p>
                </div>
            </div>
        </div>
    );
};

export default Privacy;
